module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "normal3"
  }, [_c('span', {
    staticClass: "charoverride6"
  }, [_c('br', {
    staticClass: "calibre4"
  })])]), _vm._v(" "), _c('h1', {
    staticClass: "normal3"
  }, [_c('span', {
    staticClass: "charoverride6"
  }, [_vm._v("Contents")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/Text/Title_Page",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Roman Count Down")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/Text/Chapter_1"
    }
  }, [_vm._v("Chapter One")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/Text/Chapter_2"
    }
  }, [_vm._v("Chapter Two")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/Text/Chapter_3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Three")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/Text/Chapter_4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Four")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/Text/Chapter_5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Five")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/Text/Chapter_6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Six")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/Text/Chapter_7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Seven")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/Text/Chapter_8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Eight")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/Text/Chapter_9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Nine")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/Text/Chapter_10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Ten")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/Text/Chapter_11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Eleven")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/Text/Chapter_12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Twelve")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/Text/Food_and_Wine",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Food and Wine")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/Text/Author's_Note"
    }
  }, [_vm._v("Author’s Note")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0b85cc4c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/Text/Contents.vue
// module id = 69
// module chunks = 0